/**
 * Pardavėjo (MB Teniso užsiėmimai) rekvizitai.
 */
export const DEFAULT_INVOICE_SELLER = {
  name: 'MB Teniso užsiėmimai',
  address: 'Vilniaus g. 2B, Valkininkai, LT-65438 Varėnos r.',
  companyCode: '307607828',
  /** IBAN (EUR, SEPA) */
  accountIban: 'LT61 3500 0100 1898 6006',
  bank: 'Paysera LT, UAB',
  bankCode: '35000',
  swift: 'EVIULT2VXXX',
  bankAddress: 'Pilaitės pr. 16, LT-04352, Vilnius, Lietuva',
  sepaNote: 'IBAN sąskaita skirta pervedimams tik EUR valiuta (SEPA).',
};
